import { ChimeraContractModel } from '@/models/chimera/ChimeraContractModel';

export interface UserState {
  mostRecentChimeraContract: ChimeraContractModel | null;
}

const state: UserState = {
  mostRecentChimeraContract: null,
};

export default state;
